export default __webpack_public_path__ + "static/media/Defaultbanner.78642660.png";